import React from "react";
import dashboardLogo from "../assets/dash.png";
import Footer from "./Footer";
import HotOffers from "./HotOffers";

const NewDashboard = () => {
  return (
    <div className="relative">
      <HotOffers/>
    
    </div>
  );
};

export default NewDashboard;
